<template>
 

   <div class="furn-media"> 
       <gallery/>  

        <div class="min-u animation"  style="max-width:350px;   " >
             <media-and-photograph/>  
        </div>
    </div>

</template>

<script>
import Gallery from './Gallery.vue'
import MediaAndPhotograph from '../menu/components/MediaAndPhotograph.vue'
export default {
  components: {  MediaAndPhotograph, Gallery },
    
}
</script>

<style>
.min-u{
    margin-top: 60px  !important;
    max-width: 350px;
    top: 0;
    position: fixed;
}
.animation {
  
   transition: all 1.5s linear;
 
  animation-name: example;
  animation-duration: 2s;
}

@keyframes example {
  from  {right:55%; top:0px;}
   to { right:0%; top:0px;}
  
}


</style>